import React, { Component } from "react";
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form'
import Modal from "../../../../components/UI/Modal/Modal";
import { Preloading } from '../../../../components/UI/Preloader/action';
import { Form, FormGroup, ModalHeader, ModalBody, ModalFooter, Row, Col, Button, Label } from 'reactstrap';
import { toast } from 'react-toastify';
import { fetchSortedPartnerListRequest, allocatePartnerDataToServerRequest, fetchAllocatedPartnerDataRequest, searchCounterpartyRequest, fetchAllocatedSearchDataRequest, fetchPartnerProductListRequest, fetchPartnerOrderDataRequest, upadateAdditinalDetailsRequest, reallocatePartnerRequest } from './action';
import Select from 'react-select';
import * as constant from "../../constants";
import Table from '../../../../components/UI/Table/Table'
import { sendSelected } from "./helper"
import AdditionalFieldsForm from "./AdditionalFieldsForm"
let that = this;
const columns = [
    {
        Header: "",
        id: "radio",
        accessor: p => <input type="radio" name="counterparties" value={p.companyId + "|" + p.productCode + "|" + p.productType} onChange={that.onRadioChanged} />,
        maxWidth: 2
    },
    {
        Header: "counterpartyName",
        accessor: "counterpartyName"
    },
    {
        Header: "Partner Name",
        accessor: "partnerName"
    },
    {
        Header: "Product Code",
        id: "product",
        accessor: p => p.productCode !== undefined ? p.productCode + " (" + p.productType + ")" : null
    },
    {
        Header: "companyId",
        id: "companyId",
        accessor: p => (p.tax_identifier === undefined || p.tax_identifier === null || p.tax_identifier === "") ? p.companyId : p.companyId + " (" + p.tax_identifier + ")"
    },
    {
        Header: "Address",
        accessor: "counterparty_address"
    },
    {
        Header: "City",
        accessor: "counterpartyCity"
    },
    {
        Header: "Status",
        accessor: "companyStatus"
    },
    {
        Header: "Last Updated Date",
        accessor: "updatedDate"
    }
]

class AllocatePartner extends Component {
    constructor(props) {
        super(props);
        this.state = { partnerSelectedOption: undefined, partnerList: [], searchPartnerSelectedOption: undefined, searchPartnerId: undefined, allocatedPartnerData: undefined, resizeZIndex: false, loading: false, searchCounterpartyData: undefined, selectedPartnerCompany: undefined, counterpartyName: '', partnerModal: false, confirmModal: false, productSelectedOption: undefined, productList: [], refreshConfirmModal: false, disableRefresh: false, additionalDetailsModal: false, reallocateConfirmModal: false}
        that = this;
    }

    handlePartnerChange = (option) => {
        this.setState({ partnerSelectedOption: option, productSelectedOption: undefined, productList: [] });
        let requestbody = { partnerId: option.value, productType: "NORMAL" };
        this.props.fetchPartnerProductListRequest(requestbody);
    }

    handleProductChange = (option) => {
        let requestbody = { caseId: this.props.caseId, partnerId: this.state.partnerSelectedOption.value, partnerName: this.state.partnerSelectedOption.label, productCode: option.value, productType: "NORMAL" };
        this.setState({ productSelectedOption: option, selectedPartnerCompany: requestbody })
    }

    onRadioChanged = (e) => {
        let selected = sendSelected(this.state.searchCounterpartyData, e.target.value)
        console.log(selected);
        let requestbody = { caseId: this.props.caseId, partnerId: selected.referenceId, companyId: selected.companyId, partnerName: selected.partnerName, productCode: selected.productCode, productType: selected.productType };
        this.setState({ selectedPartnerCompany: requestbody })
    }

    onCounterpartyNameChanged = (e) => {
        let namevalue = e.target.value;
        this.setState({ counterpartyName: namevalue })
    }

    handleSearchPartnerChange = (option) => {
        this.setState({
            searchPartnerSelectedOption: option,
            searchPartnerId: option ? option.value : undefined
        });
    }

    handleSearchModalButton = (type) => {
        if (type === constant.CLOSE) {
            this.props.allocatePartner();
        } else if (type == constant.SAVE) {
            if (this.state.allocatedPartnerData.partnerName !== null && !this.state.selectedPartnerCompany) {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;Please select any one record
                    </div>
                );
            } else if (!this.state.selectedPartnerCompany) {
                this.setState({ partnerModal: !this.state.partnerModal })
            } else {
                this.setState({ additionalDetailsModal: !this.state.additionalDetailsModal })
            }
        } else if (type == constant.REFRESH){
            this.setState({ refreshConfirmModal: !this.state.refreshConfirmModal })
        }
        else if (type == constant.REALLOCATE){
            this.setState({ reallocateConfirmModal: !this.state.reallocateConfirmModal })
        }
    }

    handleSearchButton = (counterpartyName) => {
        this.setState({ searchCounterpartyData: undefined, selectedPartnerCompany: undefined })
        this.props.searchCounterparty({
            counterpartyName: counterpartyName,
            countryCode: this.props.countryCode,
            partnerId: this.state.searchPartnerId
        })
        this.props.preloading(true);
        this.setState({ resizeZIndex: true })
    }

    handleConfirmModalButton = (type) => {
        if (type === constant.CLOSE) {
            this.setState({ confirmModal: !this.state.confirmModal })
        } else if (type == constant.SAVE) {
            if (this.state.selectedPartnerCompany) {
                this.props.preloading(true);
                this.props.allocatePartnerDataToServerRequest(this.state.selectedPartnerCompany);
                this.setState({ resizeZIndex: true })
                //this.props.allocatePartner();
            }
        }
    }

    handleRefreshConfirmModalButton = (type) => {
        if (type === constant.CLOSE) {
            this.setState({ refreshConfirmModal: !this.state.refreshConfirmModal })
        } else if (type == constant.SAVE) {
            this.props.fetchPartnerOrderDataRequest({ caseId: this.props.caseId });
            toast.success(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Data refresh request placed Successfully, please check data after some time.
                </div>,
            );
            this.setState({ refreshConfirmModal: !this.state.refreshConfirmModal, disableRefresh: !this.state.disableRefresh });
        }
    }

    handleReallocateConfirmModalButton = (type) => {
        if (type === constant.CLOSE) {
            this.setState({ reallocateConfirmModal: !this.state.reallocateConfirmModal })
        } else if (type == constant.SAVE) {
            this.props.reallocatePartnerRequest({ caseId: this.props.caseId });
            this.props.preloading(true);
            toast.success(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp; Reallocate Partner Request Place Successfully.
                </div>,
            );
            this.setState({ reallocateConfirmModal: !this.state.reallocateConfirmModal});
        }
    }

    handlePartnerModalButton = (type) => {
        if (type == constant.CLOSE) {
            this.setState({ partnerModal: !this.state.partnerModal, selectedPartnerCompany: undefined, partnerSelectedOption: '', productSelectedOption: '', productList: [] })
        } else if (type == constant.SAVE) {
            this.setState({ additionalDetailsModal: !this.state.additionalDetailsModal })
        }
    }

    componentDidMount() {
        this.props.fetchSortedPartnerListRequest({ countryCode: this.props.countryCode })
        this.props.fetchAllocatedPartnerDataRequest({ caseId: this.props.caseId })
        //this.props.fetchAllocatedSearchDataRequest({ caseId: this.props.caseId })
        this.setState({ counterpartyName: this.props.counterpartyName })
    }

    componentDidUpdate(prevProps) {
        if (this.props.sortedPartnerList !== prevProps.sortedPartnerList) {
            let partnerNameOptions = [];
            this.props.sortedPartnerList && this.props.sortedPartnerList.length > 0 &&
                this.props.sortedPartnerList.map(partnerNameObj => {
                    partnerNameOptions = [
                        ...partnerNameOptions, {
                            value: partnerNameObj.id, label: partnerNameObj.name
                        }
                    ]
                })
            this.setState({ partnerList: partnerNameOptions })
            /*if (this.state.allocatedPartnerData && (this.state.allocatedPartnerData).hasOwnProperty('partnerId')) {
                this.setState({ partnerSelectedOption: partnerNameOptions[partnerNameOptions.findIndex(x => x.value == this.state.allocatedPartnerData.partnerId)] })
            }*/
            if (this.props.sortedPartnerList.status === "FAILURE") {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;Fail to get ordered Partner list.
                    </div>
                );
            }
        }

        if (this.props.allocatePartnerResponse !== prevProps.allocatePartnerResponse) {
            this.props.preloading(false);
            this.setState({ resizeZIndex: false });
            if (this.props.allocatePartnerResponse.status === "SUCCESS") {
                this.props.fetchAllocatedPartnerDataRequest({ caseId: this.props.caseId });
                this.setState({ partnerModal: !this.state.partnerModal, confirmModal: !this.state.confirmModal })
                this.props.allocatePartner();
                toast.success(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;Partner allocated
                        Successfully
                    </div>,
                );
            } else {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.allocatePartnerResponse.data.message}
                    </div>
                );
            }
        }

        if (this.props.allocatedPartnerData !== prevProps.allocatedPartnerData) {
            this.setState({ allocatedPartnerData: this.props.allocatedPartnerData.data })
            /*if (this.state.partnerList.length > 0) {
                this.setState({ partnerSelectedOption: this.state.partnerList[this.state.partnerList.findIndex(x => x.value == this.props.allocatedPartnerData.data.partnerId)] })
            }*/
            if (this.props.allocatedPartnerData.status === "FAILURE") {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;Fail to get allocated Partner data.
                    </div>
                );
            }
        }

        if (this.props.searchCounterpartyData !== prevProps.searchCounterpartyData) {
            this.setState({ searchCounterpartyData: this.props.searchCounterpartyData.data, loading: false })
            this.props.preloading(false);
            this.setState({ resizeZIndex: false });
        }

        if (this.props.partnerProductList !== prevProps.partnerProductList) {
            let productOptions = [];
            this.props.partnerProductList && this.props.partnerProductList.length > 0 &&
                this.props.partnerProductList.map(productObj => {
                    productOptions = [
                        ...productOptions, {
                            value: productObj.productCode, label: productObj.productCode + " (" + productObj.productType + ")"
                        }
                    ]
                })
            this.setState({ productList: productOptions })

            if (this.props.partnerProductList.status === "FAILURE") {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;Fail to get Partner product list.
                    </div>
                );
            }
        }

        if (this.props.partnerOrderResponse !== prevProps.partnerOrderResponse) {
            if (this.props.partnerOrderResponse.status === "SUCCESS") {
                toast.success(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;Latest Data Fetched
                        Successfully
                    </div>,
                );
            } else {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;Failed to get api data
                    </div>
                );
            }
            this.setState({ resizeZIndex: false })
        }

        if (this.props.reallocatePartnerResponse !== prevProps.reallocatePartnerResponse) {
            this.props.preloading(false);
            if (this.props.reallocatePartnerResponse.status === "SUCCESS") {
                toast.success(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp; {this.props.reallocatePartnerResponse.data}
                    </div>,
                );
            } else {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;Failed to Reallocate Partner.
                    </div>
                );
            }
            this.setState({ resizeZIndex: false })
            window.location.reload();
        }

        if (this.props.updateAdditionalDetailsResponse !== prevProps.updateAdditionalDetailsResponse) {
            if (this.props.updateAdditionalDetailsResponse.status === "SUCCESS") {
                this.setState({ confirmModal: !this.state.confirmModal })
            } else {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;Failed to save Additional Details.
                    </div>
                );
            }
            this.setState({ resizeZIndex: false })
            this.props.preloading(false);
        }
    }

    submitAdditionalDetails = (formValues) => {
        let requestBody = null;
        requestBody = {
            ...formValues,
            caseId: this.props.caseId
        }
        this.props.upadateAdditinalDetailsRequest(requestBody);
        this.setState({ resizeZIndex: true })
        this.props.preloading(true);
    }

    handleAddDetailsModalButton = (type) => {
        if (type === constant.CLOSE) {
            this.setState({ additionalDetailsModal: !this.state.additionalDetailsModal })
        }
    }

    render() {
        return (<React.Fragment>
            <Modal show={this.props.open} className={(this.state.resizeZIndex || this.state.partnerModal || this.state.additionalDetailsModal || this.state.refreshConfirmModal || this.state.reallocateConfirmModal) ? "z-index-zero partner-allocate-modal Large-Modal" : " partner-allocate-modal Large-Modal"} >
                <ModalHeader className="justify-content-center">
                    Allocate Partner
                </ModalHeader>
                <ModalBody>
                    {this.state.allocatedPartnerData && this.state.allocatedPartnerData.partnerName !== null && this.state.allocatedPartnerData.status !== "UNALLOCATED" &&
                        <table className="table table-bordered border-bottom-0 case-about-table">
                            <tbody>
                                <tr>
                                    <th className="header-blue" width="30%">Partner Name</th>
                                    <td title={this.state.allocatedPartnerData.partnerName} className="text-truncate"> {this.state.allocatedPartnerData.partnerName} </td>
                                </tr>
                                <tr>
                                    <th className="header-blue" width="30%">Order Number</th>
                                    <td title={this.state.allocatedPartnerData.orderNumber} className="text-truncate"> {this.state.allocatedPartnerData.orderNumber} </td>
                                </tr>
                                <tr>
                                    <th className="header-blue" width="30%">Product</th>
                                    <td title={this.state.allocatedPartnerData.productCode} className="text-truncate"> {this.state.allocatedPartnerData.productCode} </td>
                                </tr>
                                <tr>
                                    <th className="header-blue" width="30%">Case Status</th>
                                    <td title={this.state.allocatedPartnerData.status} className="text-truncate"> {this.state.allocatedPartnerData.status} </td>
                                </tr>
                                {this.state.allocatedPartnerData && this.state.allocatedPartnerData.status === "CANCELLED" &&
                                    <tr>
                                        <th className="header-blue" width="30%">Cancellation Description</th>
                                        <td title={this.state.allocatedPartnerData.cancellationDescription} className="text-truncate"> {this.state.allocatedPartnerData.cancellationDescription} </td>
                                    </tr>
                                }
                                <tr>
                                    <th className="header-blue" width="30%">Comment</th>
                                    <td title={this.state.allocatedPartnerData.comment} className="text-truncate"> {this.state.allocatedPartnerData.comment} </td>
                                </tr>
                                <tr>
                                    <th className="header-blue" width="30%">Request Date</th>
                                    <td title={this.state.allocatedPartnerData.requestDate} className="text-truncate"> {this.state.allocatedPartnerData.requestDate !== null && this.state.allocatedPartnerData.requestDate} </td>
                                </tr>
                                <tr>
                                    <th className="header-blue" width="30%">Response Date</th>
                                    <td title={this.state.allocatedPartnerData.responseDate} className="text-truncate"> {this.state.allocatedPartnerData.responseDate !== null && this.state.allocatedPartnerData.responseDate} </td>
                                </tr>
                                <tr>
                                    <th className="header-blue" width="30%">Previous Partner Name</th>
                                    <td title={this.state.allocatedPartnerData.previousPartnerName} className="text-truncate"> {this.state.allocatedPartnerData.previousPartnerName !== null && this.state.allocatedPartnerData.previousPartnerName} </td>
                                </tr>
                            </tbody>
                        </table>
                    }
                    {(!this.state.allocatedPartnerData || this.state.allocatedPartnerData.partnerName === null || this.state.allocatedPartnerData.status === "UNALLOCATED") &&
                        <Form className="w-100" >
                            {(!this.state.allocatedPartnerData || this.state.allocatedPartnerData.partnerName === null) &&
                                <FormGroup style={{ marginLeft: "1rem" }} row>
                                    <Label sm={4}>Counterparty Name </Label>
                                    <Col sm={5}>
                                        <input className="form-control text-fields" type="text" id="counterpartyName" value={this.state.counterpartyName} onChange={this.onCounterpartyNameChanged} />
                                    </Col>
                                    <Col sm={6}>
                                        <Select
                                            value={this.state.searchPartnerSelectedOption}
                                            onChange={this.handleSearchPartnerChange}
                                            options={this.state.partnerList}
                                            placeholder="Select Partner"
                                            isClearable
                                        />
                                    </Col>
                                    <Col sm={4}>
                                        <Button color="info" size="lg" className="justify-content-center" onClick={() => this.handleSearchButton(this.state.counterpartyName)} > Search </Button>
                                    </Col>
                                </FormGroup>}

                            <Table
                                data={this.state.searchCounterpartyData}
                                columns={columns}
                                defaultPageSize={10}
                                className=""
                                noDataText="No Counterparties Available"
                                loading={this.state.loading}
                            />
                        </Form>
                    }
                </ModalBody>
                <ModalFooter>
                    <Row>
                        <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.handleSearchModalButton(constant.CLOSE)} > Close </Button></Col>
                        {(!this.state.allocatedPartnerData || this.state.allocatedPartnerData.partnerName === null || this.state.allocatedPartnerData.status === "UNALLOCATED" || this.state.allocatedPartnerData.status === "REALLOCATED") && <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.handleSearchModalButton(constant.SAVE)} > Proceed </Button></Col>}
                        {(this.state.allocatedPartnerData && this.state.allocatedPartnerData.status !== "UNALLOCATED") && <Col ><Button color="info" size="lg" className="justify-content-center" disabled={(this.state.allocatedPartnerData && this.state.allocatedPartnerData.responseDate !== null && this.state.allocatedPartnerData.status === "PENDING") || (this.state.disableRefresh)} onClick={() => this.handleSearchModalButton(constant.REFRESH)} > Refresh </Button></Col>}
                        {(this.state.allocatedPartnerData && this.state.allocatedPartnerData.status !== "UNALLOCATED") && <Col ><Button color="info" size="lg" className="justify-content-center"  onClick={() => this.handleSearchModalButton(constant.REALLOCATE)} > Reallocate </Button></Col>}
                    </Row>
                </ModalFooter>
            </Modal>
            <Modal show={this.state.partnerModal} className={(this.state.resizeZIndex || this.state.additionalDetailsModal) ? "z-index-zero partner-confirm-modal Large-Modal" : "partner-confirm-modal Large-Modal"} >
                <ModalHeader>
                    Select Partner
                </ModalHeader>
                <ModalBody>
                    <FormGroup style={{ marginLeft: "1rem" }} row>
                        <Label sm={10}>Partner Name </Label>
                        <Col sm={14}>
                            <Select
                                isDisabled={this.state.allocatedPartnerData && this.state.allocatedPartnerData.status === constant.COMPLETED}
                                value={this.state.partnerSelectedOption}
                                onChange={this.handlePartnerChange}
                                options={this.state.partnerList} />
                        </Col>
                    </FormGroup>
                    <FormGroup style={{ marginLeft: "1rem" }} row>
                        <Label sm={10}>Product</Label>
                        <Col sm={14}>
                            <Select
                                value={this.state.productSelectedOption}
                                onChange={this.handleProductChange}
                                options={this.state.productList} />
                        </Col>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.handlePartnerModalButton(constant.CLOSE)} > Cancel </Button></Col>
                    <Col ><Button color="info" size="lg" className="justify-content-center" disabled={!this.state.selectedPartnerCompany} onClick={() => this.handlePartnerModalButton(constant.SAVE)} > Save </Button></Col>
                </ModalFooter>
            </Modal>
            <Modal show={this.state.additionalDetailsModal} className={(this.state.resizeZIndex || this.state.confirmModal) ? "z-index-zero additional-details-modal Large-Modal" : "additional-details-modal Large-Modal"} >  
                <AdditionalFieldsForm additionalFields={this.props.additionalFields} submitAdditionalDetails={this.submitAdditionalDetails} handleAddDetailsModalButton={this.handleAddDetailsModalButton}/>
            </Modal>
            <Modal show={this.state.confirmModal} className={(this.state.resizeZIndex) ? "z-index-zero partner-confirm-modal Large-Modal" : "partner-confirm-modal Large-Modal"} >
                <ModalHeader>
                    Confirm
                </ModalHeader>
                <ModalBody>
                    Are you sure to place case at {this.state.selectedPartnerCompany && this.state.selectedPartnerCompany.partnerName}?
                </ModalBody>
                <ModalFooter>
                    <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.handleConfirmModalButton(constant.CLOSE)} > Cancel </Button></Col>
                    <Col><Button color="success" size="lg" className="justify-content-center" disabled={!this.state.selectedPartnerCompany} onClick={() => this.handleConfirmModalButton(constant.SAVE)}> Proceed </Button></Col>
                </ModalFooter>
            </Modal>
            <Modal show={this.state.refreshConfirmModal} className={(this.state.resizeZIndex) ? "z-index-zero partner-confirm-modal Large-Modal" : "partner-confirm-modal Large-Modal"} >
                <ModalHeader>
                    Confirm
                </ModalHeader>
                <ModalBody>
                    Are you sure to refresh case data?
                </ModalBody>
                <ModalFooter>
                    <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.handleRefreshConfirmModalButton(constant.CLOSE)} > Cancel </Button></Col>
                    <Col><Button color="success" size="lg" className="justify-content-center" onClick={() => this.handleRefreshConfirmModalButton(constant.SAVE)}> Submit </Button></Col>
                </ModalFooter>
            </Modal>
            <Modal show={this.state.reallocateConfirmModal} className={(this.state.resizeZIndex) ? "z-index-zero partner-confirm-modal Large-Modal" : "partner-confirm-modal Large-Modal"} >
                <ModalHeader>
                    Confirm
                </ModalHeader>
                <ModalBody>
                    Are you sure to Reallocate Partner?
                </ModalBody>
                <ModalFooter>
                    <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.handleReallocateConfirmModalButton(constant.CLOSE)} > Cancel </Button></Col>
                    <Col><Button color="success" size="lg" className="justify-content-center" onClick={() => this.handleReallocateConfirmModalButton(constant.SAVE)}> Submit </Button></Col>
                </ModalFooter>
            </Modal>
        </React.Fragment>)
    }
}


const mapStateToProps = (state) => ({
    sortedPartnerList: state.allocatePartnerData.sortedPartnerList,
    allocatePartnerResponse: state.allocatePartnerData.allocatePartnerResponse,
    allocatedPartnerData: state.allocatePartnerData.allocatedPartnerData,
    searchCounterpartyData: state.allocatePartnerData.searchCounterpartyData,
    partnerProductList: state.allocatePartnerData.partnerProductList,
    partnerOrderResponse: state.allocatePartnerData.partnerOrderResponse,
    reallocatePartnerResponse: state.allocatePartnerData.reallocatePartnerResponse,
    updateAdditionalDetailsResponse : state.allocatePartnerData.updateAdditionalDetailsResponse
});

const mapDispatchToProps = dispatch => ({
    fetchSortedPartnerListRequest: (data) => { dispatch(fetchSortedPartnerListRequest(data)) },
    allocatePartnerDataToServerRequest: (data) => { dispatch(allocatePartnerDataToServerRequest(data)) },
    fetchAllocatedPartnerDataRequest: (data) => { dispatch(fetchAllocatedPartnerDataRequest(data)) },
    searchCounterparty: (data) => { dispatch(searchCounterpartyRequest(data)) },
    fetchAllocatedSearchDataRequest: (data) => { dispatch(fetchAllocatedSearchDataRequest(data)) },
    fetchPartnerProductListRequest: (data) => { dispatch(fetchPartnerProductListRequest(data)) },
    fetchPartnerOrderDataRequest: (data) => { dispatch(fetchPartnerOrderDataRequest(data))},
    reallocatePartnerRequest: (data) => { dispatch(reallocatePartnerRequest(data))},
    upadateAdditinalDetailsRequest: (data) => { dispatch(upadateAdditinalDetailsRequest(data))},
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});

export default connect(mapStateToProps, mapDispatchToProps)(AllocatePartner);